












import { defineComponent, onMounted, onUnmounted, ref } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";
import UserSubscribeModal from "@/components/UserSubscribeModal";
import SubscriptionOfferModal from "../SubscriptionOfferModal";

export default defineComponent({
  name: "SubscriptionOffer",
  components: { SubscriptionOfferModal, UserSubscribeModal },
  props: {
    user: { type: Object as () => UserPublicData, required: true },
  },
  setup() {
    const showSubscriptionOffer = ref(false);
    const showSubscriptionList = ref(false);

    const handleEvents = () => {
      showSubscriptionOffer.value = true;
      emitter.off<any>(EVENTS.SUBSCRIPTION_OFFER_SHOW, handleEvents);
    };

    const onSubscriptionOffer = (value: boolean) => {
      showSubscriptionOffer.value = false;
      showSubscriptionList.value = value;
    };

    onMounted(() => {
      emitter.on<any>(EVENTS.SUBSCRIPTION_OFFER_SHOW, handleEvents);
    });
    onUnmounted(() => {
      emitter.off<any>(EVENTS.SUBSCRIPTION_OFFER_SHOW, handleEvents);
    });

    return {
      showSubscriptionOffer,
      showSubscriptionList,
      onSubscriptionOffer,
    };
  },
});
